export const halfValueOfArray = (arr: string[]): string => {
  const arrHalf = Math.floor(arr.length / 2);
  const string = arr[arrHalf];

  return string;
};
